import React, { useState } from 'react';
import '../../../entrydoor.css';
import ImageModal from '../../../components/ImageModal';

const HardwareCollection = ({
    value,
    onChange,
    label = 'Hardware Collection:',
    disabled = false,
    tilt = false,
    showPics = false
}) => {
    const [selectedHardwareCollection, setSelectedHardwareCollection] = useState(value || "Toulon");
    const [showModal, setShowModal] = useState(false);

    const handleHardwareCollectionChange = (e) => {
        setSelectedHardwareCollection(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label htmlFor="HardwareCollection" disabled={disabled}>
                {label}
                {showPics && (
                    <span
                        onClick={() => setShowModal(true)}
                        style={{
                            display: 'inline-block',
                            marginLeft: '6px',
                            width: '16px',
                            height: '16px',
                            borderRadius: '50%',
                            backgroundColor: '#007bff',
                            color: '#fff',
                            textAlign: 'center',
                            lineHeight: '16px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            userSelect: 'none'
                        }}
                        title="Click to view image"
                    >
                        i
                    </span>
                )}
            </label>

            <select
                disabled={disabled}
                id="HardwareCollection"
                value={selectedHardwareCollection}
                onChange={handleHardwareCollectionChange}
            >
                {tilt ? (
                    <>
                        <option value="Toulon">{selectedHardwareCollection === "Toulon" ? "Toulon ✔" : "Toulon"}</option>
                        <option value="Atlanta">{selectedHardwareCollection === "Atlanta" ? "Atlanta ✔" : "Atlanta"}</option>
                    </>
                ) : (
                    <option value="Liverpool">{selectedHardwareCollection === "Liverpool" ? "Liverpool ✔" : "Liverpool"}</option>
                )}
            </select>

            <ImageModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                folder="images/hardwarecollection"
                imageName={selectedHardwareCollection}
                //height={500}
            />
        </div>
    );
};

export default HardwareCollection;
